export default __webpack_public_path__ + "static/media/middle-plaque.c73794f7.png";